import { render, staticRenderFns } from "./GalleryAudio.vue?vue&type=template&id=30a896ab&scoped=true"
import script from "./GalleryAudio.vue?vue&type=script&lang=js"
export * from "./GalleryAudio.vue?vue&type=script&lang=js"
import style0 from "./GalleryAudio.vue?vue&type=style&index=0&id=30a896ab&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a896ab",
  null
  
)

export default component.exports